import { motion } from "framer-motion";
import {useLocation } from "react-router-dom";
import { translations } from "../translations";

export default function AboutSection() {
  const location = useLocation();
  const currentLang = location.pathname.split("/")[1] || "fr";
  const t = translations[currentLang];

  return (
    <div className="w-11/12 mx-auto flex flex-col md:flex-row items-center justify-between py-16 gap-10" id="about" >
      {/* Image Section */}
      <motion.div
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className="w-full md:w-1/2 overflow-hidden rounded-2xl shadow-lg"
      >
        <img
          src="/assets/about-image.jpg"
          alt="About Kim-Anh"
          className="w-full h-[750px] object-cover"
        />
      </motion.div>

      {/* Text Section */}
      <div className="w-11/12 lg:w-1/2 text-center md:text-left">
        <h2 className="text-4xl font-extrabold text-deepblue mb-4 uppercase tracking-wide">
          {t.aboutTitle}
        </h2>
        {t.aboutDescription.split("\n\n").map((paragraph, idx) => (
          <p key={idx} className="mb-4 leading-relaxed text-lg text-gray-700">
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
}
